export default class VideoInner {
  constructor() {
    this.selector = '.b-video-inner';

    this.selectors = {
      breadcrumbs: '.b-video-inner__breadcrumbs',
      breadcrumbLast: '.breadcrumb_last',
    };
  }

  bootstrap() {
    const blocks = [ ...document.querySelectorAll(this.selector) ];

    if (blocks.length === 0) {
      return;
    }

    blocks.forEach(block => {
      const breadcrumbLast = block.querySelector(this.selectors.breadcrumbs);

      if (breadcrumbLast) {
        const lastItemTitle = breadcrumbLast.dataset.lastItem;

        if (lastItemTitle && lastItemTitle.length > 0) {
          block.querySelector(this.selectors.breadcrumbLast).innerHTML = lastItemTitle; // eslint-disable-line no-param-reassign
        }
      }
    });
  }
}
